export default {
    init: function () {
        this.bind();
    },

    bind: function () {
        const _this = this;
        $(document).on("submit", "[data-ajax_form]", function (e) {
            e.preventDefault();
            const form = $(this);
            _this.submitForm(form);
        });

        $(document).on("input change", "[data-ajax_field]", function () {
            const field = $(this);
            _this.clearErrors(field);
        });
    },

    submitForm: function (form) {
        const _this = this;
        const method = "POST";
        const action = form.attr("action");
        const [actionName, queryString] = action.split("?", 2);

        let data = new FormData(form[0]);
        data.append("action", actionName);

        if (queryString) {
            new URLSearchParams(queryString).forEach((value, key) => {
                data.append(key, value);
            });
        }

        data.append("security", settings.security);

        $.ajax({
            url: settings.ajaxurl,
            data: data,
            method: method,
            processData: false,
            contentType: false,
            beforeSend: function () {
                if (_this.xhr) {
                    _this.xhr.abort();
                }
                _this.lockForm(form);
            },
            success: (response) => {
                this.handleResponse(response);
                this.unlockForm(form);
            },

            error: (xhr, status, error) => {
                this.handleResponse(xhr, form);
                this.unlockForm(form);
            },
        });
    },

    handleResponse: function (response, form) {
        const errors = response.responseJSON?.errors;
        if (errors) {
            this.propagateErrors(errors, form);
        }

        if (response.partials) {
            this.replacePartials(response.partials);
        }
    },

    propagateErrors: function (errors, form) {
        form.find("[data-field_error]").text("");

        Object.entries(errors).forEach(([field, fieldErrors]) => {
            const firstError = fieldErrors?.[0];

            if (!firstError) {
                return;
            }

            $(`[data-ajax_error="${field}"]`).text(firstError).closest("[data-ajax_wrapper]").addClass("has-error");
        });
    },

    clearErrors: function (field) {
        const id = field.attr("id");
        if (!id) {
            return;
        }
        $(`[data-ajax_error="${id}"]`).text("").closest("[data-ajax_wrapper]").removeClass("has-error");
    },

    lockForm: function (form) {
        form.addClass("is-loading");
    },

    unlockForm: function (form) {
        setTimeout(() => {
            form.removeClass("is-loading");
        }, 500);
    },

    replacePartials: function (partials) {
        Object.entries(partials).forEach(([selector, html]) => {
            $(selector).html(html);
        });
    },
};
